import {Component, Input} from '@angular/core';
import {MatFormFieldAppearance} from '@angular/material/form-field';
import { MatPaginator } from '@angular/material/paginator';
import { PaginatedDataSource } from "../../shared/datasource/paginated-datasource";
import { AsyncPipe } from "@angular/common";

@Component({
  selector: 'lib-pegase-paginator',
  templateUrl: './paginator.component.html',
  standalone: true,
  imports: [
    MatPaginator,
    AsyncPipe
  ]
})
export class PaginatorComponent {
  @Input()
  dataSource!: PaginatedDataSource<any>;
  @Input()
  private _formFieldAppearance: MatFormFieldAppearance = "fill";
}
